import React from "react";
import { Avatar, Badge, Box, Button, createStyles, Image, Text } from "@mantine/core";
import AnimatedWaves from "../../components/AnimatedWaves";
import { IconCalendarClock, IconPhone } from "@tabler/icons-react";

interface Details {
  status?: any;
  Questionnaire?: string;
  date?: string;
  numberOfQuestions?: string;
  additionalDetails?: string;
}

export const QuestDetails: React.FC<Details> = ({
  status,
  Questionnaire,
  date,
  numberOfQuestions,

  additionalDetails,
}) => {
  const useStyles = createStyles(() => ({
    mainBox: {
      border: "1px solid #EDEDED ",
      width: "100%",
      padding: "16px",
      borderRadius: "10px",
      gap: "24px",
      display: "flex",
      flexDirection: "column",
      minWidth: "409px",
    },
    Box1: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    Box2: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    details: {
      display: "flex",
      flexDirection: "column",
      alignContent: "space-between",
    },
    heading: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "22px",
      color: "#818999",
      display: "flex",
    },
    value: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "22px",
      color: "#262930",
      display: "flex",
      justifyContent:"center"
    },
    boxkeyDetails: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      gap: "20px",
    },
    buttonBox: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
    },
  }));

  const { classes } = useStyles();

  return (
    <>
      <Box className={classes.mainBox}>
        <Box className={classes.Box1}>
          <Box className={classes.Box2}>
            <Box className={classes.heading}>Questionnaire</Box>
            <Box className={classes.value}>{Questionnaire ?? "--"}</Box>
          </Box>
          <Box>
            {" "}
            <Badge
              radius="sm"
              size="lg"
              color={
                status === "completed"
                  ? "teal"
                  : status === "in-progress"
                  ? "orange"
                  : status === "stopped"
                  ? "red"
                  : "blue"
              }
            >
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Text>{status == 'stopped'?'Not Answered': status ?? "--"}</Text>
                {status === "in-progress" && (
                  <Box ml={4}>
                    <AnimatedWaves />
                  </Box>
                )}
              </Box>
            </Badge>
          </Box>
        </Box>
        <Box className={classes.boxkeyDetails}>
          <Box className={classes.Box2}>
            <Box className={classes.heading}>Scheduled date</Box>
            <Box className={classes.value}>{date ?? "--"}</Box>
          </Box>
          <Box className={classes.Box2}>
            <Box className={classes.heading}>No of questions</Box>
            <Box className={classes.value}>{numberOfQuestions ?? "--"}</Box>
          </Box>
          <Box className={classes.Box2}>
            <Box className={classes.heading}>No of answers</Box>
            <Box className={classes.value}>{additionalDetails ?? "--"}</Box>
          </Box>
        </Box>

      </Box>
    </>
  );
};
